import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { V3Routes } from '../../routes';
import { UserInfoPane } from '../../components/organisms/application/UserInfoPane';
import { PlanSelectionPane } from '../../components/organisms/application/PlanSelectionPane';
import { observer, Provider } from 'mobx-react';
import { observable, makeObservable } from 'mobx';
import { ApplicationPageState } from './states/ApplicationPageState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { CompletePane } from '../../components/organisms/application/CompletePane';
import { PaymentMethodPane } from '../../components/organisms/application/PaymentMethodPane';
import { ConfirmationPane } from '../../components/organisms/application/ConfirmationPane';
import { OverlaySpinner } from '../../../commonv3/components/molecules/layout/OverlaySpinner';
import { SignInPane } from '../../components/organisms/signin/SignInPane';
import { ErrorPane } from '../../components/organisms/application/ErrorPane';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { StartDateSelectionPane } from '../../components/organisms/application/StartDateSelectionPane';
import { HomeLocationSelectionPane } from '../../components/organisms/application/HomeLocationSelectionPane';
import { UserAddressPane } from '../../components/organisms/application/UserAddressPane';

type Props = RouteComponentProps;

export const ApplicationPage = withNavigation(NavigationSpecs.application())(
  observer(
    class ApplicationPage extends React.Component<Props> {
      pageState = null;
      constructor(props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });

        this.pageState = new ApplicationPageState(GlobalStatesV3.currentUser, GlobalStatesV3.routing);
      }
      componentDidMount(): void {
        this.pageState.init();
      }
      componentDidUpdate(prevProps): void {
        if (
          this.props.location.pathname !== prevProps.location.pathname &&
          this.props.location.pathname === V3Routes.application().pathname
        ) {
          this.pageState.init();
        }
      }

      render() {
        const { initing } = this.pageState;
        return (
          <>
            <Provider applicationState={this.pageState}>
              <Switch>
                <Route
                  exact
                  path={V3Routes.applicationSignIn().stringify()}
                  render={() => (
                    <SignInPane
                      redirectUrl={V3Routes.applicationUserInfo().stringify()}
                      supportNewUser={true}
                      onNewUserPreferred={() => GlobalStatesV3.routing.push(V3Routes.applicationUserInfo().stringify())}
                    />
                  )}
                />
                <Route exact path={V3Routes.applicationUserInfo().stringify()} component={UserInfoPane} />
                <Route
                  exact
                  path={V3Routes.applicationStartDateSelect().stringify()}
                  component={StartDateSelectionPane}
                />
                <Route
                  exact
                  path={V3Routes.applicationHomeLocationSelect().stringify()}
                  component={HomeLocationSelectionPane}
                />
                <Route exact path={V3Routes.applicationPlanSelect().stringify()} component={PlanSelectionPane} />
                <Route exact path={V3Routes.applicationPaymentMethod().stringify()} component={PaymentMethodPane} />
                <Route exact path={V3Routes.applicationAddressInfo().stringify()} component={UserAddressPane} />
                <Route exact path={V3Routes.applicationConfirmation().stringify()} component={ConfirmationPane} />
                <Route exact path={V3Routes.applicationError().stringify()} component={ErrorPane} />
                <Route exact path={V3Routes.applicationComplete().stringify()} component={CompletePane} />
              </Switch>
            </Provider>
            <OverlaySpinner id="application-loader" open={initing} />
          </>
        );
      }
    }
  )
);
